module.exports = __webpack_public_path__ + "img/3.1f84f631.png";